<template>
  <div
    :class="{
      'ibox-content container-style cursor-pointer': true,
      'p-bottom-0-important': isMobile,
    }"
  >
    <div
      :class="{
        'row p-left-0 p-right-0': true,
        'p-bottom-0-important': isMobile,
      }"
    >
      <div
        :class="{
          'col-md-12 col-xs-12': true,
          'p-left-0 p-right-0': !isMobile,
          'm-bottom-0-important': isMobile,
        }"
        @click="collapsed"
      >
        <div
          :class="{
            'col-md-1 col-xs-1': true,
            'p-left-0 p-right-0': !isMobile,
          }"
        >
          <a
            class="display-flex position-absolute"
            v-html="customer.customer_img"
          ></a>
          <span
            :class="{
              'member-icon-position-20':
                (customer.password == null && customer.active === 'TRUE') ||
                customer.active === 'FALSE' ||
                customer.active === '',
              'member-icon-position-16':
                customer.password != null && customer.active === 'TRUE',
            }"
            @click="memberStatus"
            v-if="
              contactData.logged_user_role_id != 1 &&
              contactData.logged_user_role_id != 9 &&
              contactData.contact_type == 'primary'
            "
          >
            <svg
              v-if="customer.password != null && customer.active === 'TRUE'"
              width="22"
              height="22"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_6043_53021)">
                <rect
                  x="5"
                  y="5"
                  width="16"
                  height="16"
                  rx="8"
                  fill="white"
                  shape-rendering="crispEdges"
                />
                <rect
                  x="4.5"
                  y="4.5"
                  width="17"
                  height="17"
                  rx="8.5"
                  stroke="white"
                  shape-rendering="crispEdges"
                />
                <path
                  d="M13 5C8.584 5 5 8.584 5 13C5 17.416 8.584 21 13 21C17.416 21 21 17.416 21 13C21 8.584 17.416 5 13 5ZM11.4 17L7.4 13L8.528 11.872L11.4 14.736L17.472 8.664L18.6 9.8L11.4 17Z"
                  fill="#37BD5D"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_6043_53021"
                  x="0"
                  y="0"
                  width="26"
                  height="26"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6043_53021"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6043_53021"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            <svg
              v-else
              width="22"
              height="22"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_6043_53002)">
                <rect
                  x="5"
                  y="5"
                  width="16"
                  height="16"
                  rx="8"
                  fill="white"
                  shape-rendering="crispEdges"
                />
                <rect
                  x="4.5"
                  y="4.5"
                  width="17"
                  height="17"
                  rx="8.5"
                  stroke="white"
                  shape-rendering="crispEdges"
                />
                <path
                  d="M13 5C8.584 5 5 8.584 5 13C5 17.416 8.584 21 13 21C17.416 21 21 17.416 21 13C21 8.584 17.416 5 13 5ZM6.6 13C6.6 9.464 9.464 6.6 13 6.6C14.48 6.6 15.84 7.104 16.92 7.952L7.952 16.92C7.104 15.84 6.6 14.48 6.6 13ZM13 19.4C11.52 19.4 10.16 18.896 9.08 18.048L18.048 9.08C18.896 10.16 19.4 11.52 19.4 13C19.4 16.536 16.536 19.4 13 19.4Z"
                  fill="#F44336"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_6043_53002"
                  x="0"
                  y="0"
                  width="26"
                  height="26"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6043_53002"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6043_53002"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            <!--              <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->

            <!--                <g filter="url(#filter0_d_6043_53021)">-->
            <!--                <rect x="5" y="5" width="16" height="16" rx="8" fill="white" shape-rendering="crispEdges"/>-->
            <!--                <rect x="4.5" y="4.5" width="17" height="17" rx="8.5" stroke="white" shape-rendering="crispEdges"/>-->
            <!--                  <path-->
            <!--                      d="M8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM12 10.872L10.872 12L8 9.128L5.128 12L4 10.872L6.872 8L4 5.128L5.128 4L8 6.872L10.872 4L12 5.128L9.128 8L12 10.872Z"-->
            <!--                      fill="#F44336"/>-->
            <!--              </g>-->
            <!--              <defs>-->
            <!--                <filter id="filter0_d_6043_53021" x="0" y="0" width="26" height="26" filterUnits="userSpaceOnUse"-->
            <!--                        color-interpolation-filters="sRGB">-->
            <!--                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>-->
            <!--                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"-->
            <!--                                 result="hardAlpha"/>-->
            <!--                  <feOffset/>-->
            <!--                  <feGaussianBlur stdDeviation="2"/>-->
            <!--                  <feComposite in2="hardAlpha" operator="out"/>-->
            <!--                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>-->
            <!--                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6043_53021"/>-->
            <!--                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6043_53021" result="shape"/>-->
            <!--                </filter>-->
            <!--              </defs></svg>-->
          </span>
        </div>

        <div
          :class="{
            'col-md-7 col-xs-7 p-right-0': true,
            'm-left-20 p-left-0': isMobile,
            'm-bottom-0-important': isMobile,
          }"
        >
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
              'p-top-4': customer.customer_business_name == '',
            }"
          >
            <div
              :id="'customer_name' + customer.customer_id"
              class="a_link_black FontSize mobile-font-size"
            >
              <div>
                <a
                  :class="{ unclickable: !customer.customer_lnk }"
                  :href="customer.customer_lnk"
                  @click="handleLinkClick"
                  class="customer-name text-decoration-none customer-technician"
                  >{{ contactData.contact_name }}</a
                >
                <customer-dropdown
                  v-if="contactData.logged_user_role_id != 9"
                  :customer="customer"
                  :contact_data="contactData"
                  :invoice-id="invoiceId"
                  :booking-info="bookingInfo"
                  :booking-id="itemId"
                >
                </customer-dropdown>
              </div>
            </div>
          </div>

          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
            v-if="
              customer.customer_business_name != '' &&
              contactData.contact_type == 'primary'
            "
          >
            <span>{{ customer.customer_business_name }}</span>
          </div>

          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <common-labels
              :unique-id="uniqueId"
              :labels="labels"
              action-name="customerSelectLabel"
              list-container="span"
              :base-url="baseUrl"
              :all-labels="allLabels"
            >
            </common-labels>
          </div>
        </div>

        <div
          :class="{
            'col-md-4 col-xs-4': true,
            'p-right-0': !isMobile,
            'p-left-0': isMobile,
          }"
        >
          <div
            :class="{
              'float-right position-relative': true,
              'top-3': !customerTradingName,
              'top-8': customerTradingName,
              'justify-content-end': isMobile,
            }"
          >
            <div
              :class="{
                'col-md-2 col-xs-2': true,
                'p-left-0 p-right-0': !isMobile,
              }"
            >
              <customer-actions-drop-down
                v-if="!customer.is_deleted"
                :customer_id="customer.customer_id"
                customerlist="0"
                :from-view-page="fromViewPage"
              >
              </customer-actions-drop-down>
            </div>
            <div :class="{ 'col-md-2 col-xs-2': true, 'p-right-0': !isMobile }">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_6043_52973)">
                  <path d="M7 10L12 15L17 10H7Z" fill="#2E4051" />
                </g>
                <defs>
                  <clipPath id="clip0_6043_52973">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="{ 'col-md-12 col-xs-12 padding-20-8': true }"
        v-if="!isCollapsed"
      >
        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0 p-top-10 p-bottom-10': !isMobile,
            'p-left-30 p-bottom-10': isMobile,
          }"
          v-if="customerTradingName"
        >
          <span>{{ customerTradingName }}</span>
        </div>

        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0': !isMobile,
          }"
        >
          <div
            :class="{
              'col-md-8 col-xs-12': true,
              'p-bottom-12': isMobile,
              'p-left-0 p-right-0': !isMobile,
            }"
            v-if="
              loggedUserRole != 'customer' &&
              forCustomerOnly &&
              showAddress &&
              businessType != 'virtual'
            "
          >
            <svg
              width="12"
              height="18"
              viewBox="0 0 14 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM2 7C2 4.24 4.24 2 7 2C9.76 2 12 4.24 12 7C12 9.88 9.12 14.19 7 16.88C4.92 14.21 2 9.85 2 7Z"
                fill="#2E4051"
              />
              <path
                d="M7 9.5C8.38071 9.5 9.5 8.38071 9.5 7C9.5 5.61929 8.38071 4.5 7 4.5C5.61929 4.5 4.5 5.61929 4.5 7C4.5 8.38071 5.61929 9.5 7 9.5Z"
                fill="#2E4051"
              />
            </svg>
            <a
              class="address-title text-decoration-none"
              :href="`https://www.google.com.au/maps?q=${lineAddress}`"
              target="_blank"
            >
              &nbsp; {{ lineAddress }}
            </a>
          </div>
          <div
            :class="{
              'p-left-0 p-right-0': !isMobile,
              'col-xs-12': isMobile,
              'col-md-4': lineAddress.length !== 0,
              'col-md-12': lineAddress.length === 0,
            }"
          >
            <div
              :class="{
                'justify-content-space-between m-bottom--20': isMobile,
                'float-right': !isMobile && lineAddress.length === 0,
                'justify-content': true,
              }"
            >
              <div :class="{ 'col-md-1': true, 'p-left-0': !isMobile }">
                <customer-call-btn
                  v-if="(contactData.credentials || {}).calls"
                  theme="circle"
                  :item-type="itemType"
                  :call_target="contactData.call_target"
                  :mobile_link="contactData.mobile_link"
                  :call_web_link="contactData.call_web_link"
                  :customer_name_without_quote="
                    contactData.contact_name_without_quote
                  "
                  :customer_numbers="contactData.customer_numbers"
                  :hasViewCredential="
                    (contactData.credentials || {}).hasViewCustomerCredential
                  "
                />
              </div>
              <div :class="{ 'col-md-1 p-right-20': true }">
                <customer-send-email-btn
                  v-if="(contactData.credentials || {}).send_email"
                  theme="circle"
                  :item-type="itemType"
                  :email_link="contactData.email_link"
                  :customer-id="customer.customer_id"
                  :invoice-id="invoiceId"
                  :booking-info="bookingInfo"
                  :booking-id="itemId"
                  :estimate-id="estimateId"
                  :has-estimate="hasEstimate"
                  :from-booking="fromViewPage"
                  :inquiry-has-booking="inquiryHasBooking"
                  :inquiry-booking-id="inquiryBookingId"
                >
                </customer-send-email-btn>
              </div>
              <div :class="{ 'col-md-1': true }">
                <customer-send-sms-btn
                  v-if="(contactData.credentials || {}).send_sms"
                  theme="circle"
                  :item-type="itemType"
                  :sms_link="contactData.sms_link"
                  :estimate-id="estimateId"
                  :has-estimate="hasEstimate"
                  :customer-id="customer.customer_id"
                  :invoice-id="invoiceId"
                  :booking-info="bookingInfo"
                  :booking-id="itemId"
                  :from-booking="fromViewPage"
                  :inquiry-has-booking="inquiryHasBooking"
                  :inquiry-booking-id="inquiryBookingId"
                ></customer-send-sms-btn>
              </div>
              <div :class="{ 'col-md-1': true }">
                <customer-chat-btn
                  theme="rectangle"
                  :discussion_lnk="contactData.discussion_lnk"
                ></customer-chat-btn>
              </div>
            </div>
          </div>
        </div>

        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0 p-top-10 p-bottom-10': !isMobile,
          }"
          v-if="loggedUserRole != 'customer' && forCustomerOnly"
        >
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <b>Time zone</b>
          </div>
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <span>
              Australia/Sydney
              {{ customerData.timezone }}
            </span>
          </div>
        </div>

        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0 p-top-10 p-bottom-10': !isMobile,
          }"
          v-if="showAddress && businessType != 'virtual'"
        >
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <b v-if="isAustralia && customerData.suburb">Suburb / Locality</b>
            <b v-else>State / Region </b>
          </div>
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <span v-if="isAustralia && customerData.suburb">
              {{ customerData.suburb }}
            </span>
            <span v-else>
              {{ customerData.state }}
            </span>
          </div>
        </div>

        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0 p-top-10 p-bottom-10': !isMobile,
          }"
          v-if="customerData.signature_id && itemType != 'booking'"
        >
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <img src="/pic/icons/signed.png" width="20" height="16" />
            <span v-if="customerData.signature_created">
              Signed on {{ customer.signature_created }}</span
            >
            <span v-else>Signed</span>
          </div>
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <a
              v-if="customerData.signature_link"
              target="_blank"
              :href="customerData.signature_link"
              class="remove-section-action"
              style="margin-top: -4px"
            >
              Show
            </a>

            <a
              v-if="customerData.signature_link"
              target="_blank"
              @click="window.confirmDelete"
              class="remove-section-action"
              style="margin-top: -4px"
            >
              Remove
            </a>
          </div>
        </div>

        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0 p-top-10 p-bottom-10': !isMobile,
          }"
          v-if="customerNotes && canAddCustomerNote"
        >
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <i
              class="fa fa-sticky-note-o"
              aria-hidden="true"
              data-toggle="tooltip"
              data-placement="top"
              title="notes"
              >&nbsp;</i
            >
            {{ customerNotes.notes }}
          </div>
        </div>

        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0 p-top-10 p-bottom-10': !isMobile,
          }"
          v-if="forCustomerOnly"
        >
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <view-attributes
              :item="customerData"
              :item-id="customerData.customer_id"
              :attributes="customerAttributes"
            >
            </view-attributes>
          </div>
        </div>

        <div
          :class="{
            'col-md-12 p-top-10': true,
            'p-left-0 p-right-0': !isMobile,
          }"
          v-if="forCustomerOnly"
        >
          <div
            :class="{
              'col-md-12 col-xs-12': true,
              'p-left-0 p-right-0': !isMobile,
            }"
          >
            <customer-properties-list
              :customer-id="customerData.customer_id"
              :country-code="countryCode"
              :date-format="dateFormat"
              :properties="properties"
              property-type="customer"
              :item-type="itemType"
              :country-key="countryKey"
              view-page="true"
            >
            </customer-properties-list>
          </div>
        </div>

        <!--Other Contacts Info-->
        <div
          :class="{
            'col-md-12 col-xs-12': true,
            'p-left-0 p-right-0': !isMobile,
          }"
          v-if="
            typeof customerData.customer_contacts != 'undefined' &&
            customerData.customer_contacts.length !== 0
          "
        >
          <hr />
          <span class="other-contact-title">Other contacts</span>
          <div
            :class="{
              'col-md-12 col-xs-12 p-left-0 p-right-0': true,
              '': !isMobile,
            }"
            v-for="(customer_contact, index) of customerData.customer_contacts"
            :key="index"
          >
            <div :class="{ 'col-md-8 col-xs-12 p-left-0 p-right-0': true }">
              <div :class="{ 'col-md-12 col-xs-12 p-left-0 p-right-0': true }">
                <div
                  :id="'customer_name' + customer_contact.customer_id"
                  class="a_link_black FontSize mobile-font-size"
                >
                  <div>
                    <a
                      :class="{ unclickable: !customer.customer_lnk }"
                      :href="customer.customer_lnk"
                      @click="handleLinkClick"
                      class="customer-name-contact text-decoration-none customer-technician"
                      >{{ customer_contact.contact_name }}</a
                    >
                    <customer-dropdown
                      v-if="customer.logged_user_role_id != 9"
                      :customer="customer"
                      :contact_data="customer_contact"
                      :invoice-id="invoiceId"
                      :booking-info="bookingInfo"
                      :booking-id="itemId"
                    >
                    </customer-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div :class="{ 'col-md-4 col-xs-12 p-left-0 p-right-0': true }">
              <div
                :class="{
                  'float-right': !isMobile,
                  'justify-content-space-between m-bottom--20': isMobile,
                  'justify-content': true,
                }"
              >
                <div :class="{ 'col-md-1': true, 'p-left-0': !isMobile }">
                  <customer-call-btn
                    v-if="(customer_contact.credentials || {}).calls"
                    theme="circle"
                    :item-type="itemType"
                    :call_target="customer_contact.call_target"
                    :mobile_link="customer_contact.mobile_link"
                    :call_web_link="customer_contact.call_web_link"
                    :customer_name_without_quote="
                      customer_contact.contact_name_without_quote
                    "
                    :customer_numbers="customer_contact.customer_numbers"
                    :hasViewCredential="
                      (customer_contact.credentials || {})
                        .hasViewCustomerCredential
                    "
                  />
                </div>
                <div :class="{ 'col-md-1 p-right-20': true }">
                  <customer-send-email-btn
                    v-if="(customer_contact.credentials || {}).send_email"
                    theme="circle"
                    :item-type="itemType"
                    :email_link="customer_contact.email_link"
                    :customer-id="customer.customer_id"
                    :contact-id="customer_contact?.id"
                    :invoice-id="invoiceId"
                    :booking-info="bookingInfo"
                    :booking-id="itemId"
                    :estimate-id="estimateId"
                    :has-estimate="hasEstimate"
                    :from-booking="fromViewPage"
                  >
                  </customer-send-email-btn>
                </div>
                <div :class="{ 'col-md-1': true }">
                  <customer-send-sms-btn
                    v-if="(customer_contact.credentials || {}).send_sms"
                    theme="circle"
                    :item-type="itemType"
                    :sms_link="customer_contact.sms_link"
                    :estimate-id="estimateId"
                    :has-estimate="hasEstimate"
                    :customer-id="customer.customer_id"
                    :invoice-id="invoiceId"
                    :booking-info="bookingInfo"
                    :booking-id="itemId"
                    :from-booking="fromViewPage"
                  ></customer-send-sms-btn>
                </div>
                <div :class="{ 'col-md-1': true }">
                  <customer-chat-btn
                    theme="rectangle"
                    :discussion_lnk="customer_contact.discussion_lnk"
                  ></customer-chat-btn>
                </div>
              </div>
            </div>

            <div :class="{ 'col-md-12 col-xs-12 p-left-0 p-right-0': true }">
              <hr
                v-if="
                  typeof customerData.customer_contacts != 'undefined' &&
                  customerData.customer_contacts.length > 1 &&
                  index !== customerData.customer_contacts.length - 1
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.unclickable {
  cursor: default;
  pointer-events: none;
}
.display-customer-contact-btns-mobile {
  display: none;
}
.customer-name {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #2e4051;
}
.text-decoration-none {
  text-decoration: none;
}
.display-flex {
  display: flex;
}
.position-absolute {
  position: absolute;
}
.member-icon-position-16 {
  display: flex;
  position: absolute;
  top: 16px;
  left: 16px;
}
.member-icon-position-20 {
  display: flex;
  position: absolute;
  top: 14px;
  left: 18px;
}
.container-style {
  border: 1px #eaecee solid;
  border-radius: 12px;
  padding: 15px 25px 15px 25px;
}
.customer-technician:hover .dropdown-content {
  display: block;
}
.cursor-pointer {
  cursor: pointer;
}
.position-relative {
  position: relative;
}
.top-8 {
  top: 8px;
}
.address-title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
}
.padding-20-8 {
  padding: 20px 0px 20px 8px;
}
.other-contact-title {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 600;
}
.customer-name-contact {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  color: #2e4051;
}
.justify-content {
  justify-content: space-evenly;
  display: flex;
}
.p-bottom-0-important {
  padding-bottom: 0 !important;
}
.m-bottom-0-important {
  margin-bottom: 0 !important;
}
@media (max-width: 768px) {
  .display-customer-contact-btns-mobile {
    display: block !important;
  }
  .icon-padding {
    padding-right: 30px;
  }
  .call-icon-first {
    padding-left: 16px;
  }
  .justify-content-end {
    display: flex;
    justify-content: flex-end;
  }
  .padding-20-8 {
    padding: 0px 0px 0px 2px;
  }
  .justify-content-space-between {
    display: flex;
    justify-content: space-between;
  }
  .m-bottom--20 {
    margin-bottom: -20px;
  }
  .member-icon-position-20 {
    left: 34px;
  }
  .member-icon-position-16 {
    left: 32px;
  }
  .col-xs-7 {
    width: 49.333%;
  }
}
</style>
<script>
import CustomerCallBtn from "./buttons/CustomerCallBtn.vue";
import CustomerDropdown from "./CustomerDropdown.vue";
import { EventBus } from "@/events/event-bus";
import CustomerActionsDropDown from "../../common/components/CustomerActionsDropDown.vue";
import CommonLabels from "../../common/components/CommonLabels.vue";
import CustomerSendEmailBtn from "./buttons/CustomerSendEmailBtn.vue";
import CustomerSendSmsBtn from "./buttons/CustomerSendSmsBtn.vue";
import CustomerChatBtn from "./buttons/CustomerChatBtn.vue";
import ViewAttributes from "../../common/components/ViewAttributes.vue";
import CustomerPropertiesList from "./CustomerPropertiesList.vue";

export default {
  name: "CustomerContact",
  components: {
    CustomerPropertiesList,
    ViewAttributes,
    CustomerChatBtn,
    CustomerSendSmsBtn,
    CustomerSendEmailBtn,
    CommonLabels,
    CustomerActionsDropDown,
    CustomerDropdown,
    CustomerCallBtn,
  },
  props: {
    customer: null,
    contactData: null,
    invoiceId: null,
    itemId: null,
    bookingInfo: null,
    fromViewPage: null,
    estimateId: null,
    itemType: null,
    hasEstimate: null,
    customerTradingName: null,
    uniqueId: null,
    labels: null,
    baseUrl: null,
    allLabels: null,
    lineAddress: null,
    loggedUserRole: null,
    forCustomerOnly: null,
    showAddress: null,
    businessType: null,
    customerData: null,
    isAustralia: null,
    customerNotes: null,
    canAddCustomerNote: null,
    customerAttributes: null,
    countryCode: null,
    dateFormat: null,
    properties: null,
    countryKey: null,
    inquiryHasBooking: 0,
    inquiryBookingId: 0,
  },
  // props: ['customer','contactData','invoiceId','itemId','bookingInfo','fromViewPage', 'estimateId',
  //         'itemType','hasEstimate','customerTradingName','uniqueId', 'labels', 'baseUrl', 'allLabels',
  //         'lineAddress','loggedUserRole','forCustomerOnly','showAddress','businessType','customerData',
  //         'isAustralia','customerNotes','canAddCustomerNote','customerAttributes','countryCode',
  //         'dateFormat','properties','countryKey'],
  data() {
    return {
      isCollapsed: true,
    };
  },
  computed: {
    emptyPassword() {
      return this.customer.password ? 0 : 1;
    },
    isMobile() {
      return this.getWidth() <= 768;
    },
  },
  mounted() {
    EventBus.$on("activateCustomer", (data) => {
      if (this.customer.password !== null) {
        this.customer.active = "TRUE";
      }
    });
    EventBus.$on("deActivateCustomer", (data) => {
      this.customer.active = "FALSE";
    });
  },
  methods: {
    handleLinkClick(event) {
      event.preventDefault();
      if (!this.customer.customer_lnk) {
        event.preventDefault();
      }
    },
    Switch_Option_Default(event) {
      if (this.customer) {
        event.preventDefault();
        event.stopImmediatePropagation(); //Works
        let input_checked_or_not = event.target.checked;
        let org_check = !input_checked_or_not;
        let customer_id = this.customer.customer_id;
        let switchOnMessage = "";
        let p_flag = this.emptyPassword;

        if (input_checked_or_not) {
          /** Activate behaviour
           *  common-views/customer_info.phtml
           *  customer/views/scripts/index/draw-node.phtml  **/
          $("#" + customer_id).prop("checked", org_check);
          switchOnMessage =
            "This customer is currently not a member. Sending a membership invitation will prompt them to create a password and complete their membership. Becoming a member will allow them to access additional features, such as managing bookings online and viewing service history" +
            "  Are you sure you want to proceed?";
          popupi_alert("Send Membership Invitation\n ", switchOnMessage);
          //$('.modal-footer').show();
          $("#popupi .modal-footer").html(
            '<a type="button" style="border-color: #03A9F4; color: #03A9F4; " class="btn btn-default" data-dismiss="modal">Close</a> ' +
              '<a type="button" style="background-color: #03A9F4; border-color: #03A9F4;" class="btn btn-info" data-dismiss="modal"  onclick = "activateMember(' +
              customer_id +
              "," +
              p_flag +
              ')" > Send Invitation </a> '
          );
        } else {
          /** deactivate behaviour **/
          $("#" + customer_id).prop("checked", org_check);
          let switchOffMessage =
            "By disabling this flag you will prevent your customer from logging into their account. Are you sure you want to continue?";
          popupi_alert("Disable Membership ", switchOffMessage);
          //$('.modal-footer').show();
          $("#popupi .modal-footer").html(
            ' <a type="button" style="border-color: #03A9F4; color: #03A9F4; " class="btn btn-default" data-dismiss="modal">Cancel</a> ' +
              '<a type="button" style="background-color: #03A9F4; border-color: #03A9F4;" class="btn btn-danger" data-dismiss="modal"  onclick = "deactivateMember(' +
              customer_id +
              "," +
              p_flag +
              ')" > Disable </a>'
          );
        }
      }
    },
    openContactDetailsModal(id) {
      EventBus.$emit("openContactDetailsModal", id);
    },

    memberStatus() {
      if (this.customer) {
        let customer_id = this.customer.customer_id;
        let switchOnMessage = "";
        let p_flag = this.emptyPassword;

        if (
          this.customer.active === "FALSE" ||
          this.customer.active === "" ||
          (this.customer.password == null && this.customer.active === "TRUE")
        ) {
          /** Activate behaviour
           *  common-views/customer_info.phtml
           *  customer/views/scripts/index/draw-node.phtml  **/
          $("#" + customer_id).prop("checked");
          switchOnMessage =
            "This customer is currently not a member. Sending a membership invitation will prompt them to create a password and complete their membership. Becoming a member will allow them to access additional features, such as managing bookings online and viewing service history. " +
            " Are you sure you want to proceed?";
          window.popupi_alert("Send Membership Invitation ", switchOnMessage);
          //$('.modal-footer').show();
          $("#popupi .modal-footer").html(
            '<a type="button" style="border-color: #03A9F4; color: #03A9F4; " class="btn btn-default" data-dismiss="modal">Close</a> ' +
              '<a type="button" style="background-color: #03A9F4; border-color: #03A9F4;" class="btn btn-info" data-dismiss="modal"  onclick = "activateMember(' +
              customer_id +
              "," +
              p_flag +
              ')" >Send Invitation </a> '
          );
        } else if (
          this.customer.password !== null &&
          this.customer.active === "TRUE"
        ) {
          /** deactivate behaviour **/
          $("#" + customer_id).prop("checked");
          let switchOffMessage =
            "By disabling this flag you will prevent your customer from logging into their account. Are you sure you want to continue?";
          window.popupi_alert("Disable Membership ", switchOffMessage);
          //$('.modal-footer').show();
          $("#popupi .modal-footer").html(
            ' <a type="button" style="border-color: #03A9F4; color: #03A9F4; " class="btn btn-default" data-dismiss="modal">Cancel</a> ' +
              '<a type="button" style="background-color: #03A9F4; border-color: #03A9F4;" class="btn btn-danger" data-dismiss="modal"  onclick = "deactivateMember(' +
              customer_id +
              "," +
              p_flag +
              ')" > Disable </a>'
          );
        }
      }
    },
    collapsed() {
      this.isCollapsed = !this.isCollapsed;
    },
    getWidth() {
      let xWidth = null;
      if (window.screen != null) xWidth = window.screen.availWidth;

      if (window.innerWidth != null) xWidth = window.innerWidth;

      if (document.body != null) xWidth = document.body.clientWidth;

      return xWidth;
    },
  },
};
</script>
